export default "__VITE_ASSET__88SGeYoR__"